import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { logger } from '@/utils';
import { environment } from '@/environment';

interface LottieAnimationProps {
  animationName: string;
  loop?: boolean;
  autoplay?: boolean;
  width?: number | string;
  height?: number | string;
}

export const LottieAnimation: React.FC<LottieAnimationProps> = props => {
  const {
    animationName,
    loop = true,
    autoplay = true,
    width = '100%',
    height = '100%',
  } = props;

  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    if (!animationName) {
      return;
    }

    const loadAnimation = async () => {
      try {
        const response = await fetch(
          `${environment.baseUrl}/animations/${animationName}.json`
        );
        if (!response.ok) {
          throw new Error(`Failed to load animation: ${response.status}`);
        }
        const data = await response.json();
        setAnimationData(data);
      } catch (err) {
        logger.error('Error loading animation', err, {
          extra: { animationName },
        });
      }
    };

    loadAnimation();
  }, [animationName]);

  if (!animationData) {
    return null;
  }

  return (
    <Lottie
      animationData={animationData}
      loop={loop}
      autoplay={autoplay}
      style={{ width, height }}
    />
  );
};
